import Box from '@mui/material/Box';
import { GameCardSystemRequirements } from '../../system/GameCardSystemRequirements';
import { OperatingSystemRequirementsListProps } from '../../system/OperatingSystemRequirementsList';
import {
  getDocs,
  getDoc,
  doc,
  collection,
  QuerySnapshot,
} from 'firebase/firestore';
import { useState, useEffect } from 'react';
import { firestore } from 'src/config/firebaseClient';
import { System } from 'functions/src/types/firestore/Game/System';
import { GameDetailsListProps } from 'src/components/system/GameDetailsList';
import { Game } from 'functions/src/types/firestore/Game';
import { ConverterFactory } from 'functions/src/util/firestore/ConverterFactory';
import { LottieLoader } from 'src/components/LottieLoader';

export type SystemTabProps = {
  id: string;
};

export const SystemTab = ({ id }: SystemTabProps) => {
  const [systemDetails, setSystemDetails] =
    useState<GameDetailsListProps | null>(null);
  const [systems, setSystems] = useState<System[]>([]);
  useEffect(() => {
    const handler = async () => {
      const systemsDoc = (await getDocs(
        collection(firestore, `Game/${id}/System`),
      )) as QuerySnapshot<System>;
      setSystems(systemsDoc.docs.map((doc) => doc.data()));
      const gameDoc = await getDoc(
        doc(firestore, `Game/${id}`).withConverter(
          ConverterFactory.buildDateConverter<Game<Date>>(),
        ),
      );
      setSystemDetails(gameDoc.data()?.systemDetails as GameDetailsListProps);
    };
    handler();
  }, [id]);
  if (!systemDetails) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <LottieLoader sx={{ height: '40px', width: '40px' }} />
      </Box>
    );
  }
  // Format for GameCardSystemRequirementsProps
  const operatingSystems: OperatingSystemRequirementsListProps[] = systems.map(
    (system) => ({
      name: system.id,
      requirements: {
        minimumRequirements: system.minRequirements,
        recommendedRequirements: system.recRequirements,
      },
    }),
  );
  const gameDetails: GameDetailsListProps = systemDetails;
  return (
    <Box px="24px">
      <GameCardSystemRequirements
        requirements={operatingSystems}
        gameDetails={gameDetails}
      />
    </Box>
  );
};
